import { useEffect, useRef } from 'react';
import { ZbarBarcodeScanner } from '@lyskraft/zbar-sdk';
import { Drawer, DrawerProps } from 'antd';
import styled from '@emotion/styled';

const StyledDrawer = styled(Drawer)`
  .ant-drawer-content-wrapper {
    height: 65vh;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    overflow: hidden;
  }

  .ant-drawer-content {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }

  .ant-drawer-header {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    text-align: center;
    padding: 16px 24px;
  }

  .ant-drawer-body {
    padding: 0;
    height: calc(100% - 64px);
  }
`;

const ScannerContainer = styled.div`
  height: 100%;
  width: 100%;
  background: #000;
  position: relative;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
`;

interface IBarcodeScannerDrawerProps extends Omit<DrawerProps, 'placement'> {
  onScan: (barcode: string) => void;
  trigger: React.ReactNode;
}

export const BarcodeScannerDrawer = ({
  onScan,
  trigger,
  ...drawerProps
}: IBarcodeScannerDrawerProps) => {
  const { open, onClose } = drawerProps;

  const containerRef = useRef<HTMLDivElement | null>(null);
  const scanner = ZbarBarcodeScanner.getInstance();

  useEffect(() => {
    if (open && containerRef.current) {
      scanner.subscribe('scan', (barcode: string) => {
        onScan(barcode);
        onClose?.({} as any);
      });

      scanner.run(containerRef.current);
    }

    if (!open) {
      scanner.unsubscribe('scan');
      scanner.stopScanning();
    }
  }, [open, onClose, onScan, scanner]);

  return (
    <>
      {trigger}

      <StyledDrawer
        title="Scan Barcode"
        placement="bottom"
        open={open}
        onClose={onClose}
        height={'70vh'}
        {...drawerProps}
        footer={null}
        destroyOnHidden
      >
        <ScannerContainer ref={containerRef} />
      </StyledDrawer>
    </>
  );
};
